// Main entry point
// Import styles
import '../scss/main.scss';

// Import components
import { Header } from './components/header.js';
import { Hero } from './components/hero.js';
import { initFooter } from './components/footer.js';
import { WowCarousel } from './components/wow-carousel.js';
import { ReviewsCarousel } from './components/reviews-carousel.js';
import { initBeforeAfterSliders } from './components/before-after-slider.js';

// Initialize app
document.addEventListener('DOMContentLoaded', () => {
  // Initialize components
  new Header();
  new Hero();
  initFooter();
  new WowCarousel();
  new ReviewsCarousel();
  initBeforeAfterSliders();
  
  console.log('ShineCraftNY app initialized');
});
